import React, { Fragment } from 'react';

const ChargeTesla = ({ city = 'toronto' }) => (
  <Fragment>
    <ol>
      <li>
        Push button on the mobile connector (charger) to open charge port
        OR when the vehicle is unlocked, you can gently push the charge
        port on the side of the vehicle (then it will open automatically)
      </li>
      <li>
        Plug in the charger until it turns green and starts blinking green.
        View how you can charge the Tesla by clicking{' '}
        <a
          className="faq__panel--link"
          href="https://www.youtube.com/watch?v=i3PR82nybf8"
          target="_blank">
          here
        </a>
      </li>
    </ol>
    <br />
    <p>
      To unplug the charger, press the button down on the mobile connector
      (charger) to unlock the charge port. Remove the charger and put it
      back into its wall mounted position.
    </p>
  </Fragment>
);

export default ChargeTesla;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ChargeTesla.js